// @flow

import { withProps } from "recompose";

import { Icon } from "@quantum/ui";

import "./icons.css";

const icon: any = type => withProps({ type })(Icon);

export const CSVIcon = icon("csv");
export const EmailIcon = icon("email");
export const Excel2Icon = icon("excel2");
export const LinkedExcelIcon = icon("linked-excel");
export const MoreOptionsIcon = icon("more-options");
export const SearchIcon = icon("search");
export const TaskIcon = icon("task");
export const TrashIcon = icon("trash");
export const OpenNewTabIcon = icon("open-new-tab");
